module.exports = __webpack_public_path__ + "img/00042.b00124ee.webp";